// Clamps (ie. cuts off) an HTML element's content by adding ellipsis to it if the content inside is too long.
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if(!isIE11) {
  document.querySelectorAll('[data-clamp]').forEach(function(content){
    // Set default number of lines to display if on is not provided
    let rows = content.dataset.clamp ? content.dataset.clamp : 2;
    $clamp(content, {clamp: rows});
  });
}
